import { colours } from "@shared/ui.design-system";

// Dynamically generate colour variants from the design system
export const generateColourVariants = () => {
  const variants: Record<string, { color: string }> = {};

  // Process each colour category
  Object.entries(colours).forEach(([category, shades]) => {
    // Skip transparency as it's not meant for text color
    if (category === "transparency") return;

    // Type assertion to help TypeScript understand the structure
    const colorShades = shades as Record<string, string>;

    // Add each shade as a variant
    Object.entries(colorShades).forEach(([shade, value]) => {
      variants[`${category}-${shade}`] = { color: value };
    });
  });

  return variants;
};
